// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/static/" + chunkId + "." + "e3cc546440311fdedee808bd478cb6d91312b4a72277565dbae8f6bba17dd5c1" + ".css";
};